module.exports = __webpack_public_path__ + "static/media/bellagio.45302401.pdf";